<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-hashtag</v-icon>
        <span class="ml-2 title">Instagram Hashtags</span>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-btn color="primary" @click="dialogAdd = true">
              Agregar
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :items="hashtags"
          :headers="headers"
          hide-default-footer
          :items-per-page="25"
        >
          <template v-slot:item.seleccionado="{ item }">
            <v-icon v-if="item.seleccionado" color="success">fas fa-check</v-icon>
            <v-icon v-else color="error">fas fa-times</v-icon>
          </template>
          <template v-slot:item.opciones="{ item }">
            <v-btn small fav text color="error" @click="deleteHashtag(item.id)">
              <v-icon>fas fa-trash</v-icon>
            </v-btn>
            <v-btn small fav text color="success" @click="selectHashtag(item.id)">
              <v-icon>fas fa-check</v-icon>
            </v-btn>
          </template>
        </v-data-table>
        <v-pagination v-model="page" :length="pages"></v-pagination>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialogAdd" max-width="400px">
      <AddHashtag
        @close="dialogAdd = false"
        @save="insertHashtag"
      ></AddHashtag>
    </v-dialog>
  </v-container>
</template>

<script>
import AddHashtag from '../components/AddHashtag'
export default {
  components: {
    AddHashtag
  },
  data () {
    return {
      hashtags: [],
      headers: [
        { text: '#Hashtag', value: 'hashtag', sortable: false },
        { text: 'Seleccionado', value: 'seleccionado', sortable: false },
        { text: 'Opciones', value: 'opciones', sortable: false }
      ],
      page: 1,
      pages: 1,
      dialogAdd: false
    }
  },
  async created () {
    await this.getPages()
    await this.getHashtags()
  },
  methods: {
    async getPages () {
      const { data } = await this.$http.hashtags.get('/count')
      this.pages = Math.ceil(data / 25)
    },
    async getHashtags () {
      const skip = (this.page - 1) * 25
      const { data } = await this.$http.hashtags.get(`?_sort=hashtag:ASC&_start=${skip}`)
      this.hashtags = data
    },
    async deleteHashtag (id) {
      if (window.confirm('¿Estas seguro de borrar el registro?')) {
        await this.$http.hashtags.delete(`/${id}`)
        await this.getPages()
        this.getHashtags()
      }
    },
    async insertHashtag (hashtag) {
      this.dialogAdd = false
      await this.$http.hashtags.post('', { hashtag })
      this.getHashtags()
    },
    async selectHashtag (id) {
      const { data } = await this.$http.hashtags.get(`?seleccionado_eq=true`)
      for (const tag of data) {
        await this.$http.hashtags.put(`/${tag.id}`, { seleccionado: false })
      }
      await this.$http.hashtags.put(`/${id}`, { seleccionado: true })
      this.getHashtags()
    }
  },
  watch: {
    page () {
      this.getHashtags()
    }
  }
}
</script>
